export enum SendDateTimeType {
  DateTime = 1,
  Period = 2,
  Gradual = 3,  

}
